import i18n from '@/i18n/i18n'

export const CONTACT_TITLE = {
  MADAM: { name: i18n.t('CompanyInformation.Ms'), code: '1' },
  SIR: { name: i18n.t('CompanyInformation.Mr'), code: '2' },
  MISS: { name: i18n.t('CompanyInformation.Miss'), code: '4' },
  UNKNOWN: { name: i18n.t('CompanyInformation.Unknown'), code: '3' }
}
